var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDash4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 29,
    viewBox: "0 0 22 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66667 0C1.64427 0 0 1.62559 0 3.625V25.375C0 27.3744 1.64427 29 3.66667 29H18.3333C20.3557 29 22 27.3744 22 25.375V9.65723C22 8.69434 21.6161 7.77109 20.9286 7.09141L14.8214 1.05918C14.1339 0.379492 13.2057 0 12.2318 0H3.66667ZM18.6484 9.96875H13.2917C12.5297 9.96875 11.9167 9.3627 11.9167 8.60938V3.31348L18.6484 9.96875Z",
    fill: "#233A80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash4);
export default __webpack_public_path__ + "static/media/dash4.4ed053993b06bb0d847a27c7f8c23bb9.svg";
export { ForwardRef as ReactComponent };